import { isNil } from "lodash";
import type { cardType, newCountryType } from "utils";
import { axiosEjFetch as axiosFetch } from "./axiosEjHelpers";
import { getAppConfiguration } from "appConfig";

const endpoint = "/api/questionCard";

export async function getQuestionCardLanguages(): Promise<newCountryType[]> {
  return axiosFetch.get("/api/country");
}

export async function getQuestionCard(questionId: string): Promise<cardType> {
  return axiosFetch.get(`${endpoint}/${questionId}`);
}

export async function getDefaultQuestionCards(
  providerId?: string
): Promise<cardType[]> {
  let urlProviderId = providerId;
  if (isNil(providerId)) {
    const appConfiguration = await getAppConfiguration();
    urlProviderId = appConfiguration.providerId;
  }

  return axiosFetch.get(`${endpoint}/getDefaultCards/${urlProviderId}`);
}

export async function getQuestionCardsForReservation(
  reservationId: string
): Promise<cardType[]> {
  return axiosFetch.get(`${endpoint}/getCustomCards/${reservationId}`);
}

export async function getAssignedCardsToReservation(
  reservationId: string
): Promise<cardType[]> {
  return axiosFetch.get(`${endpoint}/getAssignedCards/${reservationId}`);
}

export async function newQuestionCard(
  type: "default" | "custom",
  body: Omit<cardType, "id">
): Promise<cardType | null> {
  const appConfiguration = await getAppConfiguration();
  const updatedBody = {
    ...body,
    providerId: appConfiguration.providerId,
  };

  const response = await axiosFetch.post(
    `${endpoint}/${type}Card/upsert`,
    updatedBody
  );

  let createdQuestionCard: cardType | null = null;
  if (response.status === 200) {
    createdQuestionCard = response.data.questionCard;
  }

  return createdQuestionCard;
}

export async function modifyQuestionCard(
  type: "default" | "custom",
  body: cardType
) {
  const appConfiguration = await getAppConfiguration();
  const updatedBody = {
    ...body,
    providerId: appConfiguration.providerId,
  };

  return axiosFetch.post(`${endpoint}/${type}Card/upsert`, updatedBody);
}

export async function deleteQuestionCard(
  type: "default" | "custom",
  questionCardId: string
) {
  return axiosFetch.del(`${endpoint}/${type}Card/${questionCardId}`);
}

export async function assignCardsToReservation(body: {
  reservationId: string;
  questionCardIds: string[];
}) {
  return axiosFetch.post(`${endpoint}/assignCardsToReservation`, body);
}

export async function unassignCardsFromReservation(body: {
  reservationId: string;
  questionCardIds: string[];
}) {
  return axiosFetch.post(`${endpoint}/unassignCardsFromReservation`, body);
}

export async function updateCardsOrder(body: {
  reservationId: string;
  questionCardIds: string[];
}) {
  return axiosFetch.post(`${endpoint}/updateAssignedCardsOrder`, body);
}
